
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["design-iconfont",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29 29"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"x":"-81.8%","y":"-81.8%","width":"263.6%","height":"263.6%","filterUnits":"objectBoundingBox","id":"a"}},[_c('feGaussianBlur',{attrs:{"stdDeviation":"3","in":"SourceGraphic"}})])]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#165BEC","fill":"#D9E6FF","d":"M14.5 9.5a5 5 0 100 10 5 5 0 100-10z"}}),_c('path',{attrs:{"stroke":"#165BEC","filter":"url(#a)","d":"M5.5.5a5 5 0 100 10 5 5 0 100-10z","transform":"translate(9 9)"}}),_c('path',{attrs:{"fill":"#165BEC","d":"M14.5 12a2.5 2.5 0 100 5 2.5 2.5 0 100-5z"}})])])
          )
        }
      }
    